import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { firebase } from '../../core/services'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { apolloService } from '../../common/services'

import { RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS_MUTATION } from '../graphql/mutations'
import { RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS } from '../redux/action-types'

const useRetryMenuCurationTaskLabelsAndIngredientsMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateLoading: isLoading, updateError: error } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const mutate = useCallback(
    id => {
      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_MENU_TASK
          .MENU_CURATOR_RETRY_LABELS_INGREDIENTS,
        {
          menuCurationTaskId: id,
          eventCategory:
            ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_MENU_TASK,
        },
      )

      return apolloService.mutate({
        mutation: RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS_MUTATION,
        variables: { id },
        dispatch,
        action: RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS,
      })
    },
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useRetryMenuCurationTaskLabelsAndIngredientsMutation
